import { NavLink } from 'react-router-dom';
import { FiChevronRight } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const ContentSidebar = () => {
    const { t } = useTranslation();

    const menuItems = [
        { name: t('sidebar.aboutUs'), path: '/about' },
        { name: t('sidebar.contact'), path: '/contact' },
        { name: t('sidebar.faq'), path: '/faq' },
        { name: t('sidebar.shipping'), path: '/shipping' },
        { name: t('sidebar.returns'), path: '/returns' },
        { name: t('sidebar.privacy'), path: '/privacy' },
        { name: t('sidebar.kvkk'), path: '/kvkk' },
        { name: t('sidebar.distanceSales'), path: '/distance-sales-agreement' },
        { name: t('sidebar.qualityPolicy'), path: '/quality-environment-policy' },
        { name: t('sidebar.cookiePolicy'), path: '/cookie-policy' },
        { name: t('sidebar.infoSociety'), path: '/information-society-services' },
        { name: t('sidebar.compliance'), path: '/compliance-policy' },
        { name: t('sidebar.privacySecurity'), path: '/privacy-security' },
        { name: t('sidebar.orderTracking'), path: '/order-tracking' },
        { name: t('sidebar.paymentOptions'), path: '/payment-options' },
        { name: t('sidebar.transactionGuide'), path: '/transaction-guide' },
        { name: t('sidebar.siteMap'), path: '/site-map' },
        { name: t('sidebar.ringSize'), path: '/ring-size-guide' },
        { name: t('sidebar.diamondExchange'), path: '/diamond-exchange' },
    ];

    return (
        <aside className="w-full lg:w-72 flex-shrink-0">
            <div className="bg-white rounded-lg border border-gray-100 shadow-sm sticky top-24 overflow-hidden">
                <div className="p-5 border-b border-gray-100 bg-gray-50/50">
                    <h3 className="font-serif text-lg text-gray-900 tracking-wide">{t('sidebar.corporate')}</h3>
                </div>

                <nav className="p-2">
                    <ul className="space-y-1">
                        {menuItems.map((item) => (
                            <li key={item.path}>
                                <NavLink
                                    to={item.path}
                                    className={({ isActive }) => `
                                        group flex items-center justify-between px-4 py-3 rounded-md text-sm transition-all duration-300
                                        ${isActive
                                            ? 'bg-primary text-white shadow-md'
                                            : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                                        }
                                    `}
                                >
                                    <span className="font-medium tracking-wide">{item.name}</span>
                                    <FiChevronRight
                                        className={`transition-transform duration-300 ${({ isActive }) => isActive ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0'
                                            }`}
                                    />
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
        </aside>
    );
};

export default ContentSidebar;
